import React, { useState, useEffect } from 'react';

interface ICertificatesProps {
  containerWidth: number;
}

const CertificatesList = (props: ICertificatesProps) => {
  const [ open, setOpen ] = useState(false);
  const certificatesArray: string[] = [
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
    'Různé certifikované vzdělávání.',
  ]

  const { containerWidth } = props;
  console.log('state > ', open, containerWidth);
  
  useEffect(() => {
    if (containerWidth > 765) {
      console.log('set false');
      return setOpen(false)
    }
    console.log('set true');
    return setOpen(true)
  }, [containerWidth]);

  return (
  <>
    <ul className={`list certificates-list ${open ? 'open' : ''}`}>
      {certificatesArray &&
        Array.isArray(certificatesArray) &&
        certificatesArray.length > 0 &&
        certificatesArray.map((certificate: string, index: number) => {
          return (
            <li key={index}>
              {certificate}
            </li>
          );
        })
      }
    </ul>
    {!open && 
      <div className="relative-wrap t-center">
        <button 
          type="button"
          className="btn btn-default"
          onClick={() => {setOpen(true)}}
        >
          Zobrazit více
        </button>
      </div>
    }
  </>
  );
};

export default CertificatesList;